/**
 * Placement controls overlay for confirming/canceling placement actions
 */
export class PlacementControls {
    constructor() {
        this.element = null;
        this.confirmButton = null;
        this.cancelButton = null;
        this.isVisible = false;
        this.onConfirm = null;
        this.onCancel = null;
        
        this.createElement();
    }

    /**
     * Create the placement controls DOM element
     */
    createElement() {
        this.element = document.createElement('div');
        this.element.id = 'placement-controls';
        this.element.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, 80px);
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            z-index: 1001;
            display: none;
        `;

        // Create buttons container (first)
        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'flex gap-4';

        // Create confirm button (modern design)
        this.confirmButton = document.createElement('button');
        this.confirmButton.innerHTML = `
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
            </svg>
        `;
        this.confirmButton.className = 'w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-2xl font-bold transition-all duration-200 shadow-xl hover:shadow-2xl hover:scale-105 flex items-center justify-center';
        this.confirmButton.title = 'Confirmer';
        this.confirmButton.addEventListener('click', () => this.handleConfirm());

        // Create cancel button (modern design)
        this.cancelButton = document.createElement('button');
        this.cancelButton.innerHTML = `
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12"/>
            </svg>
        `;
        this.cancelButton.className = 'w-14 h-14 bg-gradient-to-br from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-2xl font-bold transition-all duration-200 shadow-xl hover:shadow-2xl hover:scale-105 flex items-center justify-center';
        this.cancelButton.title = 'Annuler';
        this.cancelButton.addEventListener('click', () => this.handleCancel());

        buttonsContainer.appendChild(this.confirmButton);
        buttonsContainer.appendChild(this.cancelButton);

        // Create help text (after buttons, smaller)
        this.helpText = document.createElement('div');
        this.helpText.textContent = 'Placez le point de connexion';
        this.helpText.className = 'text-white text-xs font-medium bg-black/60 px-3 py-1.5 rounded-lg';

        this.element.appendChild(buttonsContainer);
        this.element.appendChild(this.helpText);

        document.body.appendChild(this.element);
        console.log('✅ Placement controls created');
    }

    /**
     * Show the placement controls
     * @param {Function} onConfirm - Callback for confirm action
     * @param {Function} onCancel - Callback for cancel action
     * @param {string} helpText - Optional custom help text
     */
    show(onConfirm, onCancel, helpText = null) {
        this.onConfirm = onConfirm;
        this.onCancel = onCancel;

        // Update help text if provided
        if (helpText && this.helpText) {
            this.helpText.textContent = helpText;
        } else if (this.helpText) {
            this.helpText.textContent = 'Placez le point de connexion';
        }

        if (this.element) {
            this.element.style.display = 'flex';
            this.isVisible = true;
            console.log('🎮 Placement controls shown');
        }
    }

    /**
     * Hide the placement controls
     */
    hide() {
        if (this.element) {
            this.element.style.display = 'none';
            this.isVisible = false;
            console.log('🎮 Placement controls hidden');
        }
    }

    /**
     * Handle confirm button click
     */
    handleConfirm() {
        if (this.onConfirm) {
            this.onConfirm();
        }
        this.hide();
    }

    /**
     * Handle cancel button click
     */
    handleCancel() {
        if (this.onCancel) {
            this.onCancel();
        }
        this.hide();
    }

    /**
     * Check if controls are visible
     * @returns {boolean}
     */
    isControlsVisible() {
        return this.isVisible;
    }

    /**
     * Remove the controls from DOM
     */
    dispose() {
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
            this.confirmButton = null;
            this.cancelButton = null;
            console.log('✅ Placement controls disposed');
        }
    }
}
